if (!customElements.get('swatch-color-element')) {
  customElements.define(
    'swatch-color-element',
    class SwatchColorElement extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.addEventListener('click', (event) => {
          const li = event.target.closest('li');
          if (!li || !this.contains(li)) return;
          const thumbUrl = li.dataset.thumb;
          const thumbHoverUrl = li.dataset.thumbHover || thumbUrl;
          window.scrollToProductSliderImage(thumbUrl, this.closest('.product-card'));
          const productCard = this.closest('.product-card');
          const mainImage = productCard?.querySelector('.product-card__image--main img');
          const hoverImage = productCard?.querySelector('.product-card__image--second img');
          if (thumbUrl && mainImage) {
            mainImage.src = thumbUrl;
            mainImage.srcset = thumbUrl;
            hoverImage.src = thumbHoverUrl;
            hoverImage.srcset = thumbHoverUrl;
          }
          if (thumbUrl === thumbHoverUrl) {
            productCard?.classList.add('product-card__not-hover-image');
          } else {
            productCard?.classList.remove('product-card__not-hover-image');
          }
          this.querySelectorAll('li').forEach((el) => el.classList.remove('active'));
          li.classList.add('active');
          const quick_view = productCard?.querySelector("quick-view-modal");
          const new_url = li.dataset.urlRelated;
          if (quick_view) {
            quick_view.setAttribute("data-product-url",new_url);
          }
          const form = productCard?.querySelector("form.product-card__actions");
          if (form) {
            const variant_id = li.dataset.variant;
            const id_input = form.querySelector(`[name="id"]`);
            id_input.value = variant_id;
          }
          if (li.hasAttribute("allow-change-info")) {
            const _elTitle = productCard?.querySelector(".product-card__title a");
            const _elDesc = productCard?.querySelector(".product-card__desc");
            const _elImageWrapper = productCard?.querySelector(".product-card__image-wrapper a");
            const variant_id = li.dataset.variant;
            _elTitle.setAttribute("href", new_url);
            _elTitle.innerHTML = li.dataset.title;
            _elImageWrapper.setAttribute("href", new_url);
            _elDesc.innerHTML = li.dataset.description;
            productCard?.querySelector(".meta__price:not(.hidden)").classList.add("hidden");
            productCard?.querySelector(`.meta__price[data-id-product="${variant_id}"]`).classList.remove("hidden");
            productCard?.querySelector(".product-card__delivery:not(.hidden)").classList.add("hidden");
            productCard?.querySelector(`.product-card__delivery[data-id-product="${variant_id}"]`).classList.remove("hidden");
          }
        });

        const firstLiWithHover = this.querySelector('li[data-thumb]');
        if (firstLiWithHover) {
          const thumbUrl = firstLiWithHover.dataset.thumb;
          const hoverUrl = firstLiWithHover.dataset.thumbHover || thumbUrl;
          const productCard = this.closest('.product-card');
          const hoverImage = productCard?.querySelector('.product-card__image--second img');
          const mainImage = productCard?.querySelector('.product-card__image--main img');
          if (thumbUrl && mainImage) {
            mainImage.src = thumbUrl;
            mainImage.srcset = thumbUrl;
          }
          if (hoverUrl && hoverImage) {
            hoverImage.src = hoverUrl;
            hoverImage.srcset = hoverUrl;
          }
          if (thumbUrl === hoverUrl) {
            productCard?.classList.add('product-card__not-hover-image');
          } else {
            productCard?.classList.remove('product-card__not-hover-image');
          }
        }
      }
    }
  );
}
